import { Link } from "react-router-dom";
import { Phone, CalendarCheck } from "lucide-react";
import { business, ESTIMATE_PATH } from "@/data/site";
import { track } from "@/lib/analytics";

// Sticky bottom bar on mobile only. Two equal halves.
const MobileStickyCTA = () => {
  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 grid grid-cols-2 border-t-2 border-[#0F2E4C]" data-testid="mobile-sticky-cta">
      <a
        href={business.phoneHref}
        onClick={() => track("call_now_click", { location: "sticky-mobile" })}
        className="flex items-center justify-center gap-2 bg-[#059669] text-white font-bold uppercase text-sm py-4 active:bg-[#047857]"
        data-testid="sticky-call-btn"
      >
        <Phone className="w-5 h-5" strokeWidth={2.5} /> Call Now
      </a>
      <Link
        to={ESTIMATE_PATH}
        onClick={() => track("free_estimate_click", { location: "sticky-mobile" })}
        className="flex items-center justify-center gap-2 bg-[#0F2E4C] text-white font-bold uppercase text-sm py-4 active:bg-[#1A4A6B]"
        data-testid="sticky-estimate-btn"
      >
        <CalendarCheck className="w-5 h-5" strokeWidth={2.5} /> Free Estimate
      </Link>
    </div>
  );
};

export default MobileStickyCTA;
